// @ts-expect-error
import {COUNTRY_VALUES} from 'shells/select/country-select';
// @ts-expect-error
import {US_STATES, CANADA_STATES} from 'shells/select/state-select';

export const YES_NO_OPTIONS = [
    {
        value: '1',
        title: 'Yes',
    },
    {
        value: '0',
        title: 'No',
    },
] as const;

export const STOCK_EXCHANGE_OPTIONS = [
    {
        value: 'AMEX',
        label: 'AMEX',
    },
    {
        value: 'AMX',
        label: 'AMX',
    },
    {
        value: 'AMS',
        label: 'AMS',
    },
    {
        value: 'B3',
        label: 'B3',
    },
    {
        value: 'BME',
        label: 'BME',
    },
    {
        value: 'BSE',
        label: 'BSE',
    },
    {
        value: 'FRA',
        label: 'FRA',
    },
    {
        value: 'ICEX',
        label: 'ICEX',
    },
    {
        value: 'JPX',
        label: 'JPX',
    },
    {
        value: 'JSE',
        label: 'JSE',
    },
    {
        value: 'KRX',
        label: 'KRX',
    },
    {
        value: 'LON',
        label: 'LON',
    },
    {
        value: 'NASDAQ',
        label: 'NASDAQ',
    },
    {
        value: 'NONE',
        label: 'NONE',
    },
    {
        value: 'NYSE',
        label: 'NYSE',
    },
    {
        value: 'NSE',
        label: 'NSE',
    },
    {
        value: 'OMX',
        label: 'OMX',
    },
    {
        value: 'OTHER',
        label: 'OTHER',
    },
    {
        value: 'SEHK',
        label: 'SEHK',
    },
    {
        value: 'SGX',
        label: 'SGX',
    },
    {
        value: 'SSE',
        label: 'SSE',
    },
    {
        value: 'STO',
        label: 'STO',
    },
    {
        value: 'SWX',
        label: 'SWX',
    },
    {
        value: 'SZSE',
        label: 'SZSE',
    },
    {
        value: 'TSX',
        label: 'TSX',
    },
    {
        value: 'TWSE',
        label: 'TWSE',
    },
    {
        value: 'VSE',
        label: 'VSE',
    },
] as const;

export const OWNERSHIP_TYPES = [
    {
        value: 'government',
        label: 'Government',
    },
    {
        value: 'non-profit',
        label: 'Non-profit',
    },
    {
        value: 'private',
        label: 'Private',
    },
    {
        value: 'public',
        label: 'Public',
    },
] as const;

export const GOVERNMENT_REGISTRATION_TYPES = [
    {
        value: 'EIN',
        label: 'USA - Employer Identification Number',
    },
    {
        value: 'CBN',
        label: 'Canada - Canadian Business Number',
    },
    {
        value: 'CN',
        label: 'Great Britain - Company Number',
        isDisabled: true,
    },
    {
        value: 'ACN',
        label: 'Australia - Australian Company Number from ASIC',
        isDisabled: true,
    },
    {
        value: 'CIN',
        label: 'India - Corporate Identity Number',
        isDisabled: true,
    },
    {
        value: 'VAT',
        label: 'Estonia - VAT Number',
        isDisabled: true,
    },
    {
        value: 'VATRN',
        label: 'Romania - VAT Registration Number',
        isDisabled: true,
    },
    {
        value: 'RN',
        label: 'Israel - Registration Number',
        isDisabled: true,
    },
    {
        value: 'OTHER',
        label: 'Other',
        isDisabled: true,
    },
] as const;

export const BUSINESS_REGIONS_OF_OPERATION = [
    {
        value: 'AFRICA',
        label: 'Africa',
    },
    {
        value: 'ASIA',
        label: 'Asia',
    },
    {
        value: 'EUROPE',
        label: 'Europe',
    },
    {
        value: 'LATIN_AMERICA',
        label: 'Latin America',
    },
    {
        value: 'USA_AND_CANADA',
        label: 'USA and Canada',
    },
] as const;

export const BUSINESS_TYPES = [
    {
        value: 'Co-operative',
        label: 'Co-operative',
    },
    {
        value: 'Corporation',
        label: 'Corporation',
    },
    {
        value: 'Limited Liability Corporation',
        label: 'Limited Liability Corporation (LLC)',
    },
    {
        value: 'Non-profit Corporation',
        label: 'Non-profit corporation',
    },
    {
        value: 'Partnership',
        label: 'Partnership',
    },
] as const;

export const INDUSTRIES = [
    {
        value: 'AGRICULTURE',
        label: 'Agriculture',
    },
    {
        value: 'AUTOMOTIVE',
        label: 'Automotive',
    },
    {
        value: 'BANKING',
        label: 'Banking',
    },
    {
        value: 'CONSTRUCTION',
        label: 'Construction',
    },
    {
        value: 'CONSUMER',
        label: 'Consumer',
    },
    {
        value: 'EDUCATION',
        label: 'Education',
    },
    {
        value: 'ELECTRONICS',
        label: 'Electronics',
    },
    {
        value: 'ENGINEERING',
        label: 'Engineering',
    },
    {
        value: 'ENERGY',
        label: 'Energy',
    },
    {
        value: 'FAST_MOVING_CONSUMER_GOODS',
        label: 'Fast moving consumer goods',
    },
    {
        value: 'FINANCIAL',
        label: 'Financial',
    },
    {
        value: 'FINTECH',
        label: 'FinTech',
    },
    {
        value: 'FOOD_AND_BEVERAGE',
        label: 'Food and beverage',
    },
    {
        value: 'GOVERNMENT',
        label: 'Government',
    },
    {
        value: 'HEALTHCARE',
        label: 'Healthcare',
    },
    {
        value: 'HOSPITALITY',
        label: 'Hospitality',
    },
    {
        value: 'INSURANCE',
        label: 'Insurance',
    },
    {
        value: 'JEWELRY',
        label: 'Jewelry',
    },
    {
        value: 'LEGAL',
        label: 'Legal',
    },
    {
        value: 'MANUFACTURING',
        label: 'Manufacturing',
    },
    {
        value: 'MEDIA',
        label: 'Media',
    },
    {
        value: 'NOT_FOR_PROFIT',
        label: 'Not for profit',
    },

    {
        value: 'OIL_AND_GAS',
        label: 'Oil and gas',
    },
    {
        value: 'ONLINE',
        label: 'Online',
    },
    {
        value: 'PROFESSIONAL_SERVICES',
        label: 'Professional services',
    },
    {
        value: 'RAW_MATERIALS',
        label: 'Raw materials',
    },
    {
        value: 'REAL_ESTATE',
        label: 'Real estate',
    },
    {
        value: 'RELIGION',
        label: 'Religion',
    },
    {
        value: 'RETAIL',
        label: 'Retail',
    },
    {
        value: 'TECHNOLOGY',
        label: 'Technology',
    },
    {
        value: 'TELECOMMUNICATIONS',
        label: 'Telecommunications',
    },
    {
        value: 'TRANSPORTATION',
        label: 'Transportation',
    },
    {
        value: 'TRAVEL',
        label: 'Travel',
    },
] as const;

export const POSITIONS = [
    {
        value: 'Director',
        label: 'Director',
    },
    {
        value: 'GM',
        label: 'GM',
    },
    {
        value: 'VP',
        label: 'VP',
    },
    {
        value: 'CEO',
        label: 'CEO',
    },
    {
        value: 'CFO',
        label: 'CFO',
    },
    {
        value: 'General Counsel',
        label: 'General Counsel',
    },
    {
        value: 'Other',
        label: 'Other',
    },
] as const;

// @ts-expect-error
export const COUNTRIES = COUNTRY_VALUES.map((country) => ({
    value: country.id,
    label: country.name,
}));

// @ts-expect-error
export const REGIONS = US_STATES.concat(CANADA_STATES).map((state) => ({
    value: state.id,
    label: state.name,
}));
